export default __webpack_public_path__ + "static/media/flip_btn.a52e443c.png";